import React, {useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box,  Container, Button, useTheme, useMediaQuery } from '@mui/material';
import Grid from '../../../common/CustomGrid';
import { Link } from "react-router-dom";
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
import 'swiper/css';
import RawMarkup from '../../../common/RawMarkup'
import { FreeMode, Scrollbar, Mousewheel } from 'swiper/modules';
import AOS from 'aos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function PageContent({title, description, content, image}) {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
  const imageUrl = image?.url  ? `${baseUrl}${image.url}`   : ""; 

  const Image = () => <Box data-aos="fade-left" className='absolute-image' component="img" src={imageUrl} alt={title} /> 

   const Content = () => {
      return (
        <>
          <div className="destacado">
            <RawMarkup content={description} />
          </div>
          {!isDesktop && <Image /> }            
          <RawMarkup content={content} />
        </>
      )
    } 

  const ContentSwipper = ({contentswipper}) => {
    return (
      <Box className="page-content">
        <Swiper
        direction="vertical"
        slidesPerView="auto" 
        freeMode={true} 
        mousewheel={true} 
        scrollbar={{ draggable: true }} 
        modules={[FreeMode, Scrollbar, Mousewheel]}
        style={{ height: '75vh' }} 
        className="swiper-scroll"
      >
        <SwiperSlide>
          <Box sx={{paddingRight: 4}}>
            <Content />
          </Box>
        </SwiperSlide>
      </Swiper>
    </Box>   
    )
  }
  return (
    <>
    <Box className="solution-page-content">
      <Container maxWidth="lg">
        <Grid data-aos="fade-up" container spacing={1}>
          <Grid size={{ xs: 12, md: 6 }}>
            {isDesktop 
              ? <ContentSwipper /> 
              : <Content />
            }
            <Button data-aos="fade-up" startIcon={<ArrowForwardIcon />}  variant="contained" color="primary" component={Link} to="/contact" >
                Solicita una Demostración
            </Button>     
          </Grid>
        </Grid>
        {isDesktop && <Image />}
        
      </Container>
    </Box>
    
    </>
    
  )
}
